import { ref, onMounted } from 'vue';
import { physicalLocationApi, type PhysicalLocation } from '@/entities/Document';

export default function useFilterManagementModal() {
  const physicalLocations = ref<PhysicalLocation[]>([]);
  const loadingLocations = ref(false);
  const locationsError = ref<string | null>(null);

  const fetchPhysicalLocations = async () => {
    try {
      loadingLocations.value = true;
      locationsError.value = null;

      physicalLocations.value = await physicalLocationApi.getPhysicalLocations();
    } catch (error) {
      locationsError.value =
        error instanceof Error ? error.message : 'Erro ao carregar localizações';
      physicalLocations.value = [];
    } finally {
      loadingLocations.value = false;
    }
  };

  onMounted(() => {
    fetchPhysicalLocations();
  });

  return {
    physicalLocations,
    loadingLocations,
    locationsError,
    fetchPhysicalLocations,
  };
}
